export const featureIdIdentity = (control: {
	feature_id?: string;
}): string | undefined => control.feature_id || undefined;
